export default __webpack_public_path__ + "static/media/total-calls.64e41941.svg";